module.exports = __webpack_public_path__ + "img/advantage-title-2-new.ade82e0c.png";